import React from 'react';
import ReactDOM from 'react-dom/client';
import { HelmetProvider } from 'react-helmet-async';
import './index.css';
import App from './App';
import { preloadWithDeadline } from './routePreload';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

const render = () =>
  root.render(
    <React.StrictMode>
      <HelmetProvider>
        <App />
      </HelmetProvider>
    </React.StrictMode>
  );

// Wait for the current route's chunk before the first commit, so React never
// paints the Suspense fallback over server-rendered content the reader is already
// reading. See src/routePreload.ts for the measurements behind this.
// preloadWithDeadline never rejects and always settles, so render() always runs.
preloadWithDeadline(window.location.pathname).then(render);
